'use client';

import React, { createContext, useContext } from 'react';

/**
 * Inspector 에서 "애니메이션 추가" 를 노출할지 여부.
 *
 * 구세대 groupId 기반 그룹의 멤버는 멤버 animations 가 그룹 애니로 승격돼(canvas/group-layer.tsx)
 * 하나만 붙여도 카드 전체가 움직인다 — 그 depth 에서는 추가를 막는다. 1급 GroupItem 멤버와
 * 일반 아이템은 그대로 추가 가능(기본값 true).
 */
const AnimationAddEnabledContext = createContext(true);

export const AnimationAddEnabledProvider: React.FC<{
  isEnabled: boolean;
  children: React.ReactNode;
}> = ({ isEnabled, children }) => (
  <AnimationAddEnabledContext.Provider value={isEnabled}>
    {children}
  </AnimationAddEnabledContext.Provider>
);

export const useAnimationAddEnabled = (): boolean =>
  useContext(AnimationAddEnabledContext);
